import { Component, Input } from '@angular/core';

@Component({
    selector: 'product-size',
    styleUrls: ['./product.size.component.scss'],
    templateUrl: 'product.size.component.html',
    standalone: true
})
export class ProductSizeComponent {
  @Input() potSize: string;
  @Input() height: string;
  @Input() componentHeight: number;
}
